var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c(_vm.currentView,{tag:"component",attrs:{"query":_vm.normalizedQuery},on:{"download":_vm.handleDownload,"open-app":_vm.handleOpenApp,"add-friend":_vm.handleAddFriend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }